import { render, staticRenderFns } from "./orderReleaseGys.vue?vue&type=template&id=ba60056c&scoped=true"
import script from "./orderReleaseGys.vue?vue&type=script&lang=js"
export * from "./orderReleaseGys.vue?vue&type=script&lang=js"
import style0 from "./orderReleaseGys.vue?vue&type=style&index=0&id=ba60056c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba60056c",
  null
  
)

export default component.exports